var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { TickingClockwork } from './clockwork/TickingClockwork';
import { TickingClock } from './TickingClock';
export class RuntimeClock {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get clock_minute() {
        return this.getCustomClock(60000);
    }
    get clock_1000() {
        return this.getCustomClock(1000);
    }
    get clock_250() {
        return this.getCustomClock(250);
    }
    get clock_100() {
        return this.getCustomClock(100);
    }
    get clock_frame() {
        return this.getCustomClock('frame');
    }
    customClocks = new Map();
    getCustomClock(intervalInMs) {
        if (this.customClocks.has(intervalInMs)) {
            return this.customClocks.get(intervalInMs);
        }
        const ticking = new TickingClockwork(this, intervalInMs);
        const clock = new TickingClock(ticking);
        this.customClocks.set(intervalInMs, clock);
        return clock;
    }
    get currentDate() {
        return new Date();
    }
    get currentTime() {
        return new Date().getTime();
    }
    get serverTime() {
        return this.currentTime + window.serverTime - window.clientTime;
    }
    get currentSecondsTime() {
        return Math.floor(this.currentTime / 1000);
    }
    get currentMySqlTimestamp() {
        return new Date().mysqlTimestamp;
    }
    get currentMySqlUTCTimestamp() {
        return new Date().mysqlUTCTimestamp;
    }
    dayOfYear(date) {
        const dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        const mn = date.getMonth();
        const dn = date.getDate();
        const dayOfYear = dayCount[mn] + dn;
        return dayOfYear;
    }
    get todaysDayOfYear() {
        return this.dayOfYear(new Date());
    }
}
__decorate([
    memoize
], RuntimeClock.prototype, "clock_minute", null);
__decorate([
    memoize
], RuntimeClock.prototype, "clock_1000", null);
__decorate([
    memoize
], RuntimeClock.prototype, "clock_250", null);
__decorate([
    memoize
], RuntimeClock.prototype, "clock_100", null);
__decorate([
    memoize
], RuntimeClock.prototype, "clock_frame", null);
__decorate([
    memoize
], RuntimeClock.prototype, "todaysDayOfYear", null);
